import { useField } from "formik";
import { withT } from "neetocommons/react-utils";
import { Input } from "neetoui/formik";

import Checkbox from "./Checkbox";
import { INPUT_TYPES } from "./constants";
import DragHandle from "./DragHandle";
import OptionActions from "./OptionActions";
import { handleInputBlur, handleNumberKeyDown } from "./utils";

const MultiInputOption = withT(
  ({
    shouldFocus,
    hideDeleteOption = false,
    hideCloneOption = false,
    innerRef,
    draggableProps,
    dragHandleProps,
    onKeyDown,
    onDelete,
    onClone,
    onChange,
    optionIndex,
    disabled,
    id,
    isDraggable,
    name,
    placeholder,
    onBlur,
    arrayHelpers,
    inputConfig = [],
    isCheckboxEnabled,
  }) => (
    <div
      ref={innerRef}
      {...{ ...draggableProps, ...dragHandleProps }}
      data-testid="form-block-multi-options"
    >
      <div className="nf-multi-input-options group relative mb-2 flex items-center gap-1">
        {isDraggable && (
          <DragHandle
            {...dragHandleProps}
            data-testid={`drag-handle-${optionIndex}`}
          />
        )}
        {isCheckboxEnabled && <Checkbox {...{ name, optionIndex }} />}
        <div className="flex flex-1 flex-col gap-2">
          <div className="flex gap-2">
            {inputConfig.map((config, inputIndex) => {
              const inputName = `${name.replace(
                ".label",
                ""
              )}.values.${inputIndex}`;
              const inputType = config.type || INPUT_TYPES.TEXT;
              const isNumberType = inputType === INPUT_TYPES.NUMBER;
              const [field] = useField(inputName);

              return (
                <div className="flex-1" key={inputIndex}>
                  <Input
                    {...{ disabled }}
                    autoFocus={shouldFocus && inputIndex === 0}
                    data-testid={`multi-option-input-${optionIndex}-${inputIndex}`}
                    {...(isNumberType && {
                      min: config.min,
                      max: config.max,
                    })}
                    name={inputName}
                    type={inputType}
                    value={field.value ?? config.defaultValue}
                    placeholder={
                      config.placeholder || `${placeholder} ${inputIndex + 1}`
                    }
                    onFocus={({ target }) => target.select()}
                    onBlur={event =>
                      handleInputBlur(event, {
                        id,
                        inputIndex,
                        onChange,
                        onBlur,
                        field,
                        config,
                      })
                    }
                    onChange={({ target }) =>
                      onChange({ id, value: target.value, inputIndex })
                    }
                    onKeyDown={event =>
                      isNumberType
                        ? handleNumberKeyDown(event, onKeyDown)
                        : onKeyDown?.(event)
                    }
                  />
                </div>
              );
            })}
          </div>
        </div>
        <OptionActions
          {...{
            arrayHelpers,
            disabled,
            hideCloneOption,
            hideDeleteOption,
            id,
            onClone,
            onDelete,
            optionIndex,
          }}
        />
      </div>
    </div>
  )
);

export default MultiInputOption;
